<template>
  <validated-form
    v-slot="{ errors }"
    ref="form"
    auto-focus
    form-id="addOrderProviderServiceForm"
    @valid-submit="addOrderProviderStoreService"
  >
    <modal-card title="Add Order Provider Service">
      <validated-input label="Order Provider Services" name="orderProviderServices" rules="required">
        <b-dropdown
          v-model="selectedId"
          inline
          expanded
          :class="errors.orderProviderServices && errors.orderProviderServices.length && 'has-errors'"
        >
          <b-dropdown-item
            v-for="service in availableOrderProviderServices"
            :key="service.id"
            :value="service.id"
            :disabled="isExisting(service.id)"
            :class="isExisting(service.id) && 'is-active'"
          >
            {{ service.description }}
          </b-dropdown-item>
        </b-dropdown>
      </validated-input>
      <template #footer>
        <div class="buttons all-bold">
          <b-button rounded @click="$_confirmCloseModal({ programmatic: true })">
            Cancel
          </b-button>
          <b-button
            v-tabbable
            rounded
            native-type="submit"
            type="is-primary"
            :loading="loading"
            :disabled="!selectedId || isExisting(selectedId)"
          >
            Add
          </b-button>
        </div>
      </template>
    </modal-card>
  </validated-form>
</template>

<script>
  import OrderProviderService from '@/store/classes/OrderProviderService';
  import OrderProviderStoreService from '@/store/classes/OrderProviderStoreService';
  import confirmModalCloseMixin from '@/mixins/confirm-modal-close';

  export default {
    name: 'AddOrderProviderServiceModal',

    mixins: [confirmModalCloseMixin],

    props: {
      storeId: {
        type: Number,
        required: true
      },
      existingOrderProviderServiceIds: {
        type: Array,
        required: true
      }
    },

    data() {
      return {
        selectedId: null
      };
    },

    computed: {
      availableOrderProviderServices() {
        return OrderProviderService.all();
      },

      loading() {
        return OrderProviderStoreService.$state().creating;
      }
    },

    created() {
      OrderProviderService.fetchOrderProviderServices();
    },

    methods: {
      isExisting(orderProviderServiceId) {
        return this.existingOrderProviderServiceIds.includes(orderProviderServiceId);
      },

      async addOrderProviderStoreService() {
        try {
          const selectedService = this.availableOrderProviderServices.find(s => s.id === this.selectedId);

          if (!selectedService) {
            throw new Error('Selected service not found');
          }

          await OrderProviderStoreService.createStoreService(this.storeId, {
            orderProviderServiceId: this.selectedId,
            isActive: false
          });

          this.$_onRequestSuccess({
            toastOptions: {
              message: 'Order Provider Service successfully added!',
              duration: 2000
            }
          });
          this.$parent.close();
        }
        catch (error) {
          this.$_onRequestError({
            error,
            toastOptions: {
              message: 'Unable to add Order Provider Service'
            }
          });
        }
      }
    }
  };
</script>
